"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridItemSearch = exports.UserAvatar = exports.GridItemMenu = exports.GridItemWishlist = exports.CartButton = exports.GridItemAvatar = exports.ExpandMenuButton = exports.ButtonLine = exports.ButtonsWrapper = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.ButtonsWrapper = (0, app_1.styled)(ui_1.Grid) `
  border-left: ${(theme, { $cartView }) => $cartView ? 'none' : `1px solid ${theme.stroke}`};
  grid-column: 8;
  padding: 0 ${(theme) => theme.spacing.extraSmall};
  grid-gap: ${(theme, { $cartView }) => $cartView ? theme.spacing.extraSmall : 0};

  @media ${app_1.notDesktop} {
    grid-column: 2;
    grid-template-columns: ${(_, { $wishlistPath, $cartView }) => $cartView
    ? `repeat(2, 2rem)`
    : $wishlistPath
        ? `repeat(3, 3.5rem)`
        : 'repeat(3, minmax(0,1fr))'};
    border-left: none;
    margin-left: auto;
    padding-right: 0;
  }

  svg {
    color: ${(theme) => theme.colors.primary};
  }
`;
exports.ButtonLine = app_1.styled.div `
  width: 1.5625rem;
  height: 0.0625rem;
  background: currentColor;
  position: absolute;
  transition: all 0.3s ease;
`;
exports.ExpandMenuButton = app_1.styled.button `
  position: relative;
  z-index: 10;
  padding: 0;
  border-left: 1px solid ${(theme) => theme.stroke};
  height: var(--nav-height);
  width: 3.5rem;
  color: ${(theme) => theme.colors.primary};
  > div:first-child {
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
  }
  > div:last-child {
    bottom: 40%;
    right: 50%;
    transform: translateX(50%);
  }
  ${(_, { $active }) => $active &&
    (0, app_1.css) `
      > div:first-child {
        left: 40%;
      }
      > div:last-child {
        right: 40%;
      }
    `}
`;
exports.GridItemAvatar = (0, app_1.styled)(ui_1.GridItem) `
  @media ${app_1.notDesktop} {
    display: ${(_, { $cartView }) => ($cartView ? 'grid' : 'none')};
  }
`;
exports.CartButton = app_1.styled.button `
  color: inherit;
`;
exports.GridItemWishlist = (0, app_1.styled)(ui_1.GridItem) `
  @media ${app_1.notDesktop} {
    display: ${(_, { $cartView }) => ($cartView ? 'grid' : 'none')};
  }
`;
exports.GridItemMenu = (0, app_1.styled)(ui_1.GridItem) `
  display: none;
  height: var(--nav-height);
  width: 3.5rem;
  @media ${app_1.notDesktop} {
    display: grid;
  }
`;
exports.UserAvatar = (0, app_1.styled)(ui_1.Avatar) `
  background: ${(theme) => theme.colors.primary};
  > svg {
    color: white !important;
    height: 1rem !important;
    width: 1rem !important;
  }
`;
exports.GridItemSearch = (0, app_1.styled)(ui_1.GridItem) `
  display: none;
  @media ${app_1.notDesktop} {
    display: grid;
  }
`;
